export const getDateDifferenceInYears = (date) => {
  if (!date) return "N/A";
  const givenDate = new Date(date);
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const diffTime = Math.abs(currentDate - givenDate);
  // Convert milliseconds to years
  const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25);

  // Determine the display format
  let displayText;
  if (diffYears < 1) {
    displayText = "1 Year";
  } else if (diffYears < 2) {
    displayText = "1+ Years";
  } else {
    displayText = Math.floor(diffYears) + "+ Years";
  }

  return displayText;
};

export function formatToMonthYear(dateString) {
  if (dateString === "" || dateString === null) return "--";
  const date = new Date(dateString);
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();
  return `${month} ${year}`;
}

export function formatToDateMonthYear(dateString) {
  if (dateString === "" || dateString === null || dateString === undefined)
    return "--";
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) return "--";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
}
